import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Container,
  Row,
  Button,
  Input,
  Spinner,
} from "reactstrap";
import OnlyHeader from "components/Layout/OnlyHeader.js";
import { toast } from "react-toastify";
import { addNewUser } from "store/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { getAllAdmins } from "store/actions/subAdminAction";
import { updateSubAdmin } from "store/actions/subAdminAction";
import { deleteSubAdmin } from "store/actions/subAdminAction";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import EditSubAdmin from "components/Modals/EditSubAdmin";
import AddSubAdmin from "components/Modals/AddSubAdmin";
import TableComponent from "components/shared/Table";

import Pagination from "components/shared/Pagination";

const SubAdmin = () => {
  const dispatch = useDispatch();
  const {
    isLoading,
    adminsData,
    adminsRestData,
    isLoadingUpdate,
    isLoadingDelete,
  } = useSelector((state) => state.admin);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchField, setSearchField] = useState("");
  const [hitsPerPage, setHitsPerPage] = useState(5);
  const [addLoading, setAddLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
  });
  const [id, setId] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const pageRoles = ["sub-admin", "analyst"];

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const addtoggle = () => {
    clearData();
    setAddModal(!addModal);
  };
  const edittoggle = () => {
    setEditModal(!editModal);
  };

  const deletetoggle = () => {
    setDeleteModal(!deleteModal);
  };

  const clearData = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      role: "",
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setAddLoading(true);
    let obj = {
      name: formData?.firstName + " " + formData?.lastName,
      email: formData?.email,
      password: formData?.password,
      type: "admin",
      role: formData?.role,
    };
    dispatch(
      addNewUser(
        obj,
        [],
        () => {
          setTimeout(() => {
            setAddLoading(false);
            clearData();
            addtoggle();
            toast.success(
              `${
                obj.role === "sub-admin" ? "Sub-Admin" : "Analyst"
              } added and verification email has been sent`
            );
            dispatch(getAllAdmins(searchField, hitsPerPage, currentPage));
          }, 3000);
        },
        () => {
          setAddLoading(false);
        }
      )
    );
  };

  const handleUpdateAdmin = (event) => {
    event.preventDefault();
    const currentId = id;

    let obj = {
      name: formData?.firstName + " " + formData?.lastName,
      role: formData?.role,
    };
    dispatch(
      updateSubAdmin(currentId, obj, () => {
        edittoggle();
        toast.success("Staff Updated SuccessFully");
        dispatch({
          type: "UPDATE_ADMIN",
          payload: {
            id: currentId,
            obj,
          },
        });
        clearData();
      })
    );
  };

  const HandleDeleteBtn = () => {
    const currentId = id;

    dispatch(
      deleteSubAdmin(currentId, () => {
        deletetoggle();
        dispatch({
          type: "DELETE_ADMIN",
          payload: currentId,
        });
        setTimeout(() => {
          dispatch(getAllAdmins(searchField, hitsPerPage, currentPage));
        }, 3000);
      })
    );
  };

  useEffect(() => {
    dispatch(getAllAdmins(searchField, hitsPerPage, currentPage));
  }, [dispatch, searchField, hitsPerPage, currentPage]);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="d-xl-flex d-sm-block justify-content-between">
                <h3 className="mb-0 mb-lg-2 mb-md-2 mb-sm-2 pt-2 col-xl-2 ">
                  Sub-Admin
                </h3>
                <Input
                  className="col-xl-4 mx-1 my-2 mb-lg-2 mb-md-2 mb-sm-2 my-sm-0"
                  placeholder="Search by name or email"
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value)}
                />
                <Input
                  className="col-xl-3 mx-1 my-2 mb-lg-2 mb-md-2 mb-sm-2 my-sm-0"
                  type="select"
                  id="exampleCustomSelect"
                  name="customSelect"
                  value={hitsPerPage}
                  onChange={(e) => {
                    setHitsPerPage(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="5">Show Entries</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Input>
                <Button
                  className="col-xl-2 mx-1 my-2 mb-lg-2 mb-md-2 mb-sm-2 my-sm-0"
                  color="primary"
                  onClick={addtoggle}
                >
                  Add
                </Button>
              </CardHeader>

              <TableComponent
                className="align-items-center table-flush"
                responsive
              >
                <thead className="thead-light">
                  <tr>
                    <th scope="col">First Name</th>
                    <th scope="col">Last Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Role</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <Spinner color="primary" />
                    </td>
                  </tr>
                ) : (
                  <>
                    {adminsData?.length > 0 ? (
                      <tbody>
                        {adminsData &&
                          adminsData?.map((item, index) => {
                            const nameParts = item?.name
                              ? item.name.split(" ")
                              : ["", ""];
                            return (
                              <tr key={index}>
                                <td className="text-capitalize">{nameParts[0] || "N/A"}</td>
                                <td className="text-capitalize">{nameParts[1] || "N/A"}</td>
                                <td> {item?.email}</td>
                                <td className="text-capitalize">
                                  {" "}
                                  {item?.role}
                                </td>
                                <td>
                                  <Button
                                    className="btn-sm"
                                    color="primary"
                                    onClick={() => {
                                      setId(item?.id);
                                      setFormData({
                                        firstName: nameParts[0] || "N/A",
                                        lastName: nameParts[1] || "N/A",
                                        email: item?.email || "",
                                        role: item?.role || "",
                                      });
                                      edittoggle();
                                    }}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    className="btn-sm"
                                    color="danger"
                                    onClick={() => {
                                      setId(item?.id);
                                      deletetoggle();
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-5">
                          No Restaurant Added
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </TableComponent>
              <CardFooter>
                <Pagination
                  currentPage={currentPage}
                  totalPages={adminsRestData?.nbPages || 0}
                  onPageChange={handleClick}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddSubAdmin
          addModal={addModal}
          addtoggle={addtoggle}
          handleSubmit={handleSubmit}
          formData={formData}
          handleInputChange={handleInputChange}
          pageRoles={pageRoles}
          loading={addLoading}
        />

        {/* Modal for edit restaurant Details */}
        <EditSubAdmin
          editModal={editModal}
          edittoggle={edittoggle}
          handleUpdateAdmin={handleUpdateAdmin}
          formData={formData}
          handleInputChange={handleInputChange}
          pageRoles={pageRoles}
          isLoading={isLoadingUpdate}
        />

        <ConfirmationModal
          title="Delete Restaurant"
          text={"Are you sure you want to delete?"}
          isOpen={deleteModal}
          toggle={deletetoggle}
          isLoading={isLoadingDelete}
          onConfirmation={HandleDeleteBtn}
        />
      </Container>
    </>
  );
};

export default SubAdmin;
